import React, { useState,useEffect } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

function HrManagement() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState(1);

  const users = [
    {
      sNo: 1,
      userId: "Roles-001",
      userName: "Dr. Aarthi Kumar",
      password: "Roles-001",
      role: "Doctor",
      department: "Homeopathy",
      mobileNumber: "9768549851",
      status: "Active",
    },
    {
      sNo: 2,
      userId: "Roles-002",
      userName: "Karan Mehta",
      password: "Roles-002",
      role: "Receptionist",
      department: "Front Office",
      mobileNumber: "9768549851",
      status: "Active",
    },
    {
      sNo: 3,
      userId: "Roles-003",
      userName: "S. Deepika",
      password: "Roles-003",
      role: "HR",
      department: "HR & Payroll",
      mobileNumber: "9768549851",
      status: "Active",
    },
    {
      sNo: 4,
      userId: "Roles-004",
      userName: "Arun Natarajan",
      password: "Roles-004",
      role: "Admin",
      department: "Administration",
      mobileNumber: "9768549851",
      status: "Active",
    },
  ];

  const filteredUsers = users.filter(
    (user) =>
      user.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.userId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.department.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  return (
    <>
      <div className="p-3">
        <div className="text-end">
          <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#01AEBE" }}
            // onClick={() => navigate("/hr-management/add-hr_management")}
          >
            + Add Hr
          </button>
        </div>
        <div className="card card-body mt-2">
          <div className="bg-white rounded shadow-sm mt-3">
            <div className="row mb-4 crm-table-toolbar">
              <div className="col-md-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-table"></i>
                  </span>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      setCurrentPage(1);
                    }}
                  >
                    <option value="All">Show All</option>
                    {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
                      <option key={n} value={n}>
                        Show {n}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6"></div>
              <div className="col-md-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pe-5"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ width: "250px", paddingRight: "2.5rem" }}
                    />
                    <Search
                      size={16}
                      className="position-absolute text-muted"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table responsive-table">
                <thead className="table-light">
                  <tr style={{ backgroundColor: "#01AEBE" }}>
                    <th>S.No</th>
                    <th>Roles_id</th>
                    <th>Roles Name</th>
                    <th>Password</th>
                    <th>Role</th>
                    <th>Department</th>
                    <th>Mobile_Number</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((user, index) => (
                    <tr key={user.userId} className="align-middle">
                      <td>{user.sNo}</td>
                      <td>{user.userId}</td>
                      <td>{user.userName}</td>
                      <td>{user.password}</td>
                      <td>{user.role}</td>
                      <td>{user.department}</td>
                      <td>{user.mobileNumber}</td>
                      <td>
                        <span className="d-flex align-items-center gap-1">
                          <span
                            style={{ color: "#20c997", fontSize: "0.875rem" }}
                          >
                            {user.status}
                          </span>
                        </span>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-3">
                          <i className="fas fa-trash"></i>
                          <div className="position-relative">
                            <i className="fas fa-edit"></i>
                            <span className="red-dot"></span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center p-4 border-top">
              <button className="btn btn-outline-secondary d-flex align-items-center gap-2">
                <i className="fas fa-chevron-left"></i>
                Previous
              </button>

              <div className="d-flex gap-1">
                {[1, 2, 3, "...", 8, 9, 10].map((page, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm ${
                      page === 1 ? "text-white" : "btn-outline-secondary"
                    }`}
                    style={
                      page === 1
                        ? { backgroundColor: "#20c997", border: "none" }
                        : {}
                    }
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button className="btn btn-outline-secondary d-flex align-items-center gap-2">
                Next
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HrManagement;
